export const array_move = (
  arr: unknown[],
  fromIndex: number,
  toIndex: number
) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};
